import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  ${({ satinblack, transparent }) => (satinblack ? `
    background: ${theme.colors.satinblack};
    color: ${theme.colors.white};
  ` : (!transparent && `
    background: white;

    &:nth-child(2n + 1) {
      background: ${theme.colors.gray18};
    }
  `))}

  ${({ horizontal }) => !horizontal && `
    padding-top: ${theme.unit * 6}px;
    padding-bottom: ${theme.unit * 6}px;
  `}
  ${({ vertical }) => !vertical && `
    padding-left: ${theme.unit}px;
    padding-right: ${theme.unit}px;

    @media screen and (min-width: ${theme.mobile}px) {
      padding-left: ${theme.unit * 2}px;
      padding-right: ${theme.unit * 2}px;
    }
  `}
`);



// WEBPACK FOOTER //
// ./src/components/blocks/Section.js